var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    {
      class: [_vm.namespace(), _vm.skinStyle],
      attrs: { role: "img", alt: _vm.starAlt }
    },
    [
      _vm.value >= 1 && _vm.value <= 5
        ? _c(
            "span",
            _vm._l(_vm.stars, function(index) {
              return _c(
                "svg",
                {
                  key: index,
                  class: _vm.mdsNS("icon button__icon button_msstar")
                },
                [
                  _c("use", { attrs: { "xlink:href": "#star-fill" } }, [
                    _c("title", [_vm._v(_vm._s(_vm.starLabel))])
                  ])
                ]
              )
            }),
            0
          )
        : _c("span", [_vm._v("—")])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }